const LOAN_CALCULATOR_LIMITS = {
  AMOUNT_MAX: 10000000,
  MONTHLY_PAYMENT_MAX: 100000,
  ADMINISTRATION_FEE_MAX: 1000,
  ARRANGEMENT_FEE_MAX: 100000,
};

export default LOAN_CALCULATOR_LIMITS;
